// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/wifi-off.js';

import { paths } from '../generated/wifi-off';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('wifi-off', Original, paths);
